// src/redux/reducers/learningContentReducer.js
// ---------------------------------------------

const initialState = {
  outcomeId: null,
  belongsTo: {},
  item: null,
  unitCode: null,

  /* Learner-vs-Editor flags */
  isLearner: undefined, // undefined → treat as editor
  learnerUid: null,
  /* Editing toolbar
     Editors should start with the toolbar ON, so true  */
  isEditing: true,
};

const learningContentReducer = (state = initialState, action) => {
  switch (action.type) {
    /* ───────── core data ───────── */
    case "SET_LEARNING_CONTENT":
      return { ...state, ...action.payload };

    case "CLEAR_LEARNING_CONTENT":
      return initialState;

    case "SET_UNIT_CODE":
      return { ...state, unitCode: action.payload };

    /* --------------------------------------------------
       unit context
       -------------------------------------------------- */
    case "SET_UNIT_CONTEXT":
      return { ...state, unitContext: action.payload };

    case "CLEAR_UNIT_CONTEXT":
      return { ...state, unitContext: null };

    /* ───────── learner / editor switch ───────── */
    case "SET_LEARNER_VIEW":
      return {
        ...state,
        isLearner: action.payload.isLearner,
        learnerUid: action.payload.learnerUid, // null when editor
        isEditing: !action.payload.isLearner, // false = learner view
      };

    /* ───────── explicit editing toggle ───────── */
    case "SET_IS_EDITING":
      return { ...state, isEditing: action.payload };

    default:
      return state;
  }
};

export default learningContentReducer;
